<style lang="sass">
@import 'sass/machineSlider'
</style>

<template>
    <Zone
        id="machineSlider"
        align="center"
        contrast="light"
        class="g_center g_machineSlider">

        <template slot="before">
            <template>
                <Heading
                    :level="2"
                    :content="$json.machineSlider.title"/>
            </template>
            <div
                class="g_bg g_bg_machine"
                v-img-src="{ folder: 'machinesSlider', name: $json.machineSlider.background }" />
            <div :id="componentId" class="" v-show="isCarouselLoaded">
                <div :key="index" v-for="(slide, index) in $json.machineSlider.contents">
                    <img class="g_visual" v-img-src.sync="{ folder: 'machinesSlider/machines', name: slide.machineImg, ext: 'png' }" />
                </div>
            </div>
            <Paragraph
                v-show="isCarouselLoaded"
                size="L"
                :content="$json.machineSlider.contents[this.currentIndex].content"
                class="g_itemCopy"/>
            <Cta
                type="text"
                :content="$json.machineSlider.ctaText+' ' "
                :link="$json.machineSlider.ctaLink"
                @click="tracking('freeTrial','Click CTA - Contact Us')"
                class="g_btnGold"
                isBtn />
        </template>
    </Zone>
</template>

<script>
import Zone from 'gvue/src/core/Zone'
import Tracking from 'nespresso-library/src/core/tracking'

export default {
    name: 'MachineSlider',
    components: {
        Zone
    },
    data () {
        return {
            isCarouselLoaded: false,
            currentIndex: 0
        }
    },
    computed: {
        componentId () {
            return `g_carousel_${this._uid}`
        },
        background () {
            return this.$json.machineSlider.contents[this.currentIndex || 0].background
        }
    },
    mounted () {
        import(/* webpackChunkName: "Carousel" */ 'nespresso-components/carousel/carousel.js').then(async m => {
            await this.$nextTick()
            const machineItemsLength = this.$json.machineSlider.contents.length
            const autoLoopMachineItems = this.$json.machineSlider.autoLoopContents
            this.isCarouselLoaded = true
            const Carousel = m.default
            const carouselElement = document.getElementById(this.componentId)
            var carousel = new Carousel(carouselElement, {
                slidesToScroll: 1,
                slidesVisible: 1,
                navigationButton: machineItemsLength > 1,
                loop: machineItemsLength > 1,
                pagination: machineItemsLength > 1
            })
            let setIntervalResource
            let autoLoop = autoLoopMachineItems
            carouselElement.onmouseover = () => {
                autoLoop = false
            }
            carouselElement.onmouseout = () => {
                autoLoop = autoLoopMachineItems
            }
            const autoLoopCarousel = () => {
                if (!autoLoop) {
                    return
                }
                carousel.next()
            }

            carousel.onSlideChange(carousel => {
                // Prevent to change it after manually scroll
                if (setIntervalResource) {
                    clearInterval(setIntervalResource)
                    setIntervalResource = setInterval(autoLoopCarousel, 5000)
                }
                this.currentIndex = carousel._currentIndex
                const trackingLabel = this.$json.machineSlider.contents[carousel._currentIndex].trackingLabel || ''

                Tracking.customEvent({
                    category: 'User Engagement',
                    action: 'Slider Change',
                    label: `${this.$landing.trackingLabelPrefix} - Slider - ${trackingLabel}`,
                    interaction: 1
                })
            })

            setIntervalResource = setInterval(autoLoopCarousel, 5000)
        })
    }
}
</script>
